import Component from '@glimmer/component'
import { ScrollToTop } from 'teacher-ui-client/components/footer-main/scroll-to-top'
import { Partner } from 'teacher-ui-client/components/footer-main/partner'
import { FooterNav } from 'teacher-ui-client/components/footer-main/nav'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { Copyright } from 'teacher-ui-client/components/footer-main/copyright'

interface Signature {
  Element: HTMLElement
  Args: {
    countryCode: string
  }
}

export class FooterWriting extends Component<Signature> {
  get aboutUrl() {
    return 'https://writinglegends.com.au/about-us'
  }

  get privacyUrl() {
    return 'https://readingeggs.com.au/privacy'
  }

  <template>
    <footer class="footer-main-bg-image-writing bg-wl-blue-300 flex flex-none pt-3 pb-2 print:hidden" ...attributes>
      <div class="w-1/4 text-right">
        <Partner @subscriptionType={{SubscriptionType.Writing}} />
      </div>

      <div class="w-1/2 text-center">
        <FooterNav @aboutUrl={{this.aboutUrl}} @privacyUrl={{this.privacyUrl}} />
        <Copyright class="mt-3" @subscriptionType={{SubscriptionType.Writing}} />
      </div>

      <div class="w-1/4 text-left">
        <ScrollToTop class="mb-2" />
      </div>
    </footer>
  </template>
}

export default FooterWriting
